export default __webpack_public_path__ + "static/media/respuestaS.e8791439.png";